module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.routers), function(item) {
    return _c('nav', [_c('router-link', {
      attrs: {
        "to": item.url
      },
      domProps: {
        "textContent": _vm._s(item.urlName)
      }
    })], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('router-view', {
    staticClass: "view"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                    Vue demo\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05b3ed5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 21
// module chunks = 0